import { IPageInfo, IUserInfo } from '@umu/umu-types';
import { Dispatch } from 'react';
/**
 * @desc 开关状态
 */
enum SWITCH_STATUS {
    NO = 0,
    YES = 1,
}
/**
 * @desc 搜索成员类型
 */
enum MEMBER_TYPE {
    USER = 'user',
    GROUP = 'group',
    CLASS = 'class',
    DEPARTMENT = 'department',
    ENTERPRISE = 'enterprise',
}
enum SEARCH_MEMBER_TYPE {
    PERSONAL = 1, // 个人
    DEPARTMENT = 2, // 部门
}
enum SEARCH_PAGE_TYPE {
    INDEX,
    SEARCH,
}
/**
 * @desc 搜索类型-当前只有部门搜索
 */
enum SEARCH_TYPE {
    KNOWLEDGE_POINT_DEPARTMENT,
    WORKSPACE_DEPARTMENT,
}
enum SEARCH_PAGE_ACT_TYPE {
    INIT_DATA,
    UPDATE_LIST,
    UPDATE_PAGE_TYPE,
    UPDATE_SELECT_LIST,
}
interface IKnowledgePointConfig {
    is_admin: SWITCH_STATUS;
    is_enable_knowledge_point: SWITCH_STATUS;
    is_show_department_knowledge_point: SWITCH_STATUS;
    knowledge_point_update_time: string;
    manage_top_department_id: string;
}
interface ISearchUserInfo extends IUserInfo {
    knowledge_point_config: IKnowledgePointConfig;
}
interface IParamsUrls {
    memberType: SEARCH_MEMBER_TYPE;
    searchType: SEARCH_TYPE;
    searchId: string;
    fromTo?: string | null;
    fromUrl?: string | null;
    isMultiple?: boolean;
}

enum CAN_SELECT_STATUS {
    NO = 0,
    YES = 1,
}
interface IMemberInfo {
    id: string;
    name: string;
    email: string;
    login_name: string;
    phone: string;
    type: MEMBER_TYPE;
    user_num: number;
    avatar: string;
    is_manage: SWITCH_STATUS;
    is_department_manager: SWITCH_STATUS;
    path?: IDepartmentSearchPathInfo[];
    can_select?: CAN_SELECT_STATUS;
    has_child?: SWITCH_STATUS;
}

interface IAppInitData {
    pageType: SEARCH_PAGE_TYPE;
    currentUserInfo: ISearchUserInfo;
    switchConfig: Record<string, boolean>; // 功能属性开关
    paramsInfo: IParamsUrls;
}
interface IRefDepartmentPointsParams {
    searchId: string;
    isRoot: SWITCH_STATUS;
    page: number;
}
interface ISearchPageState extends IAppInitData {
    isLoading: boolean;
    dataKnowledgePointDepartmentInfo?: IDepartmentSearchRes;
    dataKnowledgePointDepartmentParams?: IRefDepartmentPointsParams;
    selectMemberList?: IMemberInfo[];
    workspaceDepartmentInfo?: IDepartmentSearchRes;
    workspaceDepartmentParams?: IRefDepartmentPointsParams;
}
interface ISearchPageAction {
    type: SEARCH_PAGE_ACT_TYPE;
    payload: any;
}
interface ISearchPageProps {
    state: ISearchPageState;
    dispatch: Dispatch<ISearchPageAction>;
}
interface IDepartmentSearchPathInfo {
    id: string;
    name: string;
    parent_id: string;
}
/**
 * @desc 知识点部门搜索接口参数
 */
interface IDepartmentSearchParams {
    is_root: SWITCH_STATUS;
    page: number;
    size: number;
    current_department_id: string;
}
interface IDepartmentSearchRes {
    path: IDepartmentSearchPathInfo[];
    list: IMemberInfo[];
    page_info: IPageInfo;
}
/******************************end*/
export {
    SEARCH_TYPE,
    IParamsUrls,
    SWITCH_STATUS,
    SEARCH_PAGE_TYPE,
    IAppInitData,
    IMemberInfo,
    MEMBER_TYPE,
    IDepartmentSearchParams,
    IDepartmentSearchRes,
    SEARCH_PAGE_ACT_TYPE,
    IDepartmentSearchPathInfo,
    ISearchPageState,
    ISearchPageAction,
    ISearchPageProps,
    SEARCH_MEMBER_TYPE,
    ISearchUserInfo,
    CAN_SELECT_STATUS,
};
